import Vuex from 'vuex';
import Vue from 'vue'
Vue.use(Vuex)
export default new Vuex.Store({
  state:{
    token:'',
    userName:'',
    orderSupervision:{}
  },
  getters:{
    // getuserName(){

    // }
  },
  mutations:{
    setToken(state,num){
      state.token=num;
    },
    setName(state,name){
      state.userName=name
    },
    setOrderSupervision(state,name){
      state.orderSupervision=name
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js